import { render, staticRenderFns } from "./NeoPoseView.vue?vue&type=template&id=54098e5b&scoped=true"
import script from "./NeoPoseView.vue?vue&type=script&lang=ts"
export * from "./NeoPoseView.vue?vue&type=script&lang=ts"
import style0 from "./NeoPoseView.vue?vue&type=style&index=0&id=54098e5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54098e5b",
  null
  
)

export default component.exports